/// <amd-module name="VSSUI/PivotBar" />
export * from "./Components/PivotBar/index";
